import { createContext } from 'react';
import { FillInTheBlanksTempAnswerModel } from '../../pinComponents/FillInTheBlankAreaPinComponent/utils/blankInteraction';

export interface FillInTheBlanksInteractionContextValue {
  activeWord: number | null;
  handleClickBlank: (pos: number) => void;
  answers: FillInTheBlanksTempAnswerModel;
  isAnswerCorrect: (index: number) => boolean;
  isEditing: boolean;
  isResultsPhase: boolean;
}

export const FillInTheBlanksInteractionContext = createContext<FillInTheBlanksInteractionContextValue>({
  activeWord: null,
  handleClickBlank: () => {},
  answers: {},
  isEditing: true,
  isAnswerCorrect: () => false,
  isResultsPhase: false,
});
